// Mobile Experience
export const M_MOBEXP_LOADED = 'M_MobExp_Loaded'
export const M_MOBEXP_REG_AVAILABLE = 'M_MobExp_RegAvailable'
export const M_MOBEXP_REGBUTTON_TAPPED = 'M_MobExp_RegButton_Tapped'
export const M_MOBEXP_STOP_LOADED = 'M_MobExp_Stop_Loaded'
export const M_MOBEXP_STOP_LOADED_MAX_EVENTS_SENT = 2
export const M_EXP_10_SECOND_MARK = 'M_Exp_10_Second_Mark'
export const M_LANGUAGE_ICON_CLICKED = 'M_MobExp_Language_Icon_Clicked'
export const M_LANGUAGE_SELECTED = 'M_MobExp_Language_Selected'
export const M_MOBEXP_ADA_MODE = 'M_MobExp_ADA_Mode'

// Welcome Prompt
export const M_MOBEXP_REGWELCOME_VIEWED = 'M_MobExp_RegWelcome_Viewed'
export const M_MOBEXP_REGWELCOME_CLOSED = 'M_MobExp_RegWelcome_Closed'
export const M_WELREG_POPUP_VIEWED = 'M_WelReg_PopUp_Viewed'
export const M_WELREG_POPUP_CLOSED = 'M_WelReg_PopUp_Closed'
export const M_WELREG_REGBUTTON_TAPPED = 'M_WelReg_RegButton_Tapped'
export const M_WELREG_STEP2_VIEWED = 'M_WelReg_Step2_Viewed'
export const M_WELREG_STEP2_CLOSED = 'M_WelReg_Step2_Closed'
export const M_WELREG_FINISHEDBUTTON_TAPPED = 'M_WelReg_FinishedButton_Tapped'
export const M_WELREG_SUCCESS_VIEWED = 'M_WelReg_Success_Viewed'
export const M_WELREG_OKBUTTON_TAPPED = 'M_WelReg_OkButton_Tapped'
export const M_WELREG_STARTBUTTON_TAPPED = 'M_WelReg_StartButton_Tapped'

// Direct registration
export const M_DIRREG_POPUP_VIEWED = 'M_DirReg_PopUp_Viewed'
export const M_DIRREG_POPUP_CLOSED = 'M_DirReg_PopUp_Closed'
export const M_DIRREG_REGBUTTON_TAPPED = 'M_DirReg_RegButton_Tapped'
export const M_DIRREG_STEP2_VIEWED = 'M_DirReg_Step2_Viewed'
export const M_DIRREG_STEP2_CLOSED = 'M_DirReg_Step2_Closed'
export const M_DIRREG_FINISHEDBUTTON_TAPPED = 'M_DirReg_FinishedButton_Tapped'
export const M_DIRREG_SUCCESS_VIEWED = 'M_DirReg_Success_Viewed'
export const M_DIRREG_OKBUTTON_TAPPED = 'M_DirReg_OkButton_Tapped'

// Skip stop registration
export const M_SKIPSTOPREG_POPUP_VIEWED = 'M_SkipStopReg_PopUp_Viewed'
export const M_SKIPSTOPREG_POPUP_CLOSED = 'M_SkipStopReg_PopUp_Closed'
export const M_SKIPSTOPREG_REGBUTTON_TAPPED = 'M_SkipStopReg_RegButton_Tapped'
export const M_SKIPSTOPREG_STEP2_VIEWED = 'M_SkipStopReg_Step2_Viewed'
export const M_SKIPSTOPREG_STEP2_CLOSED = 'M_SkipStopReg_Step2_Closed'
export const M_SKIPSTOPREG_FINISHEDBUTTON_TAPPED = 'M_SkipStopReg_FinishedButton_Tapped'
export const M_SKIPSTOPREG_SUCCESS_VIEWED = 'M_SkipStopReg_Success_Viewed'
export const M_SKIPSTOPREG_OKBUTTON_TAPPED = 'M_SkipStopReg_OkButton_Tapped'

// CTA's
export const M_MOBEXP_CTABUTTON_TAPPED = 'M_MobExp_CTAButton_Tapped'
export const M_MOBDRAWER_CTABUTTON_TAPPED = 'M_MobDrawer_CTAButton_Tapped'
export const M_ACTNOW_VIEWED = 'M_ActNow_Viewed'
export const M_WHATSNEXT_VIEWED = 'M_WhatsNext_Viewed'

// Skipped Registration
export const SKIPPED_REGISTRATION = 'Skipped_registration'

//HybirdApp Events
export const M_LETS_GO_VISIBLE = 'M_LetsGo_Visible'
export const M_LETS_GO_BUTTON_CLICKED = 'M_LetsGo_Button_Clicked'
export const M_LETS_GO_PROCEED_BROWSER_CLICKED = 'M_LetsGo_ProceedToBrowser_Clicked'
export const M_MOBEXP_VRBUTTON_VISIBLE = 'M_MobExp_VRbutton_Visible'
export const M_MOBEXP_VRBUTTON_CLICKED = 'M_MobExp_VRbutton_Clicked'
export const M_MOBEXP_SIDEWAY_VISIBLE = 'M_MobExp_Sideway_Visible'
export const M_MOBEXP_SIDEWAY_CLICKED = 'M_MobExp_Sideway_Clicked'
export const M_MOBEXP_VR_EXITED = 'M_MobExp_VR_Exited'

// Payments
export const M_SCENEPAY_AVAILABLE = 'M_ScenePay_Available'
export const M_SCENEPAY_BUTTON_CLICKED = 'M_ScenePay_Button_Clicked'
export const M_ITEMDET_POPUP_VIEWED = 'M_ItemDet_PopUp_Viewed'
export const M_ITEMDET_POPUP_CLOSED = 'M_ItemDet_Popup_Closed'
export const M_ITEMDET_BUY_CLICKED = 'M_ItemDet_Buy_Clicked'
export const M_ITEMDET_FACEBOOK_CLICKED = 'M_ItemDet_Facebook_Clicked'
export const M_ITEMDET_GOOGLE_CLICKED = 'M_ItemDet_Google_Clicked'
export const M_ITEMDET_GUEST_CLICKED = 'M_ItemDet_Guest_Clicked'
export const M_ITEMDET_EXPRESSCHECKOUT_VIEWED = 'M_ItemDet_ExpressCheckout_Viewed'
export const M_ITEMDET_EXPRESSCHECKOUT_CLICKED = 'M_ItemDet_ExpressCheckout_Clicked'
export const M_SHIPDETS_VIEWED = 'M_ShipDets_Viewed'
export const M_SHIPDETS_SUBMIT = 'M_ShipDets_Submit'
export const M_SHIPDETS_SUBMIT_ERROR = 'M_ShipDets_Submit_Error'
export const M_SHIPDETS_CLOSED = 'M_ShipDets_Closed'
export const M_PAYMETH_VIEWED = 'M_PayMeth_Viewed'
export const M_PAYMETH_CLOSED = 'M_PayMeth_Closed'
export const M_PAYMETH_SUBMIT = 'M_PayMeth_Submit'
export const M_PAYMETH_SUBMIT_ERROR = 'M_PayDets_Submit_Error'
export const M_ORDDETS_VIEWED = 'M_OrdDets_Viewed'
export const M_ORDDETS_PLACEORDER_CLICKED = 'M_OrdDets_PlaceOrder_Clicked'
export const M_ORDDETS_PLACEORDER_ERROR = 'M_OrdDets_PlaceOrder_Error'
export const M_ORDDETS_PLACEORDER_SUCCESS = 'M_OrdDets_PlaceOrder_Success'
export const M_ORDDETS_CLOSED = 'M_OrdDets_Closed'
export const M_ITEMPURCHASED_VIEWED = 'M_ItemPurchased_Viewed'
export const M_ITEMPURCHASED_CLOSED = 'M_ItemPurchased_Closed'
export const M_ITEMPURCHASED_CONTINUE = 'M_ItemPurchased_Continue'
